import { RentalStatus } from "../api/requests/interfaces/Channel";

export enum SOCKET_CONNECTION_TYPE {
    ROOM = "room",
    INBOX = "inbox"
}

export interface ChatRentalStatusChangeWebsocketNotification {
    status: RentalStatus
}